<template>
    <div>
        <div style="display: flex;width: 100%;justify-content: flex-end;padding:20px 30px ;">
            <span @click="closeQuery" style="cursor:pointer"> <i class="fas fa-close"
                    style="height:30px;width: 30px;color: #fff;"></i></span>

        </div>

        <div class="container">
            <!-- <div class="search-header">
            <h1>查找产品</h1>
            <p>快速找到您需要的产品</p>
        </div> -->




            <div class="search-container custom">
                <div class="search-box">
                    <i class="fas fa-search search-icon"></i>
                    <input type="text" class="search-input" placeholder="搜索产品..." v-model="searchQuery"
                        @input="handleSearch" @focus="showResults = true">
                    <button class="search-btn" @click="performSearch">
                        <i class="fas fa-paper-plane"></i> 搜索
                    </button>
                </div>
            </div>

            <div class="search-suggestions">
                <div style="color: white;padding: 8px 16px; font-size: 1.2rem;">
                    <i class="fas fa-fire" style="color:#e86a2d;margin:0 10px;"></i> 热门搜索：
                </div>
                <div class="suggestion-tag" v-for="(item, index) in recommenedProduct" :key="index"
                    @click="applySuggestion(item.name)">
                    {{ item.name }}
                </div>
            </div>


            <div class="features">
                <div class="item-grid" v-if="searchResults.length > 0">
                    <div class="item-card" v-for="item in searchResults" :key="item.id">
                        <div class="item-image">
                            <img :src="$globalUploadArr + item.imageUrl" :alt="item.name" loading="lazy">
                        </div>
                        <div class="card-content">
                            <h3>{{ item.name }}</h3>
                            <p class="desc-text">
                                {{ item.simpleIntroduce }}</p>
                            <a @click="jumpProductDetailPage(item.id)">了解更多 <i class="fas fa-arrow-right"></i></a>
                        </div>
                    </div>

                </div>
            </div>
            <!-- <div class="features">
            <div class="feature-card">
                <i class="fas fa-bolt feature-icon"></i>
                <h3>快速响应</h3>
                <p>基于Vue.js的响应式设计，搜索体验流畅，结果实时更新。</p>
            </div>

            <div class="feature-card">
                <i class="fas fa-history feature-icon"></i>
                <h3>搜索历史</h3>
                <p>自动保存您的搜索记录，方便快速访问之前的搜索内容。</p>
            </div>

            <div class="feature-card">
                <i class="fas fa-lightbulb feature-icon"></i>
                <h3>智能推荐</h3>
                <p>根据热门搜索和您的历史记录，提供智能搜索建议。</p>
            </div>
        </div> -->

            <div class="search-history" v-if="searchHistory.length > 0">
                <h3><i class="fas fa-clock"></i> 搜索历史</h3>
                <div class="history-items">
                    <div class="history-item" v-for="(item, index) in searchHistory" :key="index"
                        @click="applySuggestion(item)">
                        <i class="fas fa-search"></i> {{ item }}
                    </div>
                </div>
                <button class="clear-history" @click="clearHistory">
                    <i class="fas fa-trash-alt"></i> 清除历史记录
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { productApi } from '../../api';
export default {
    name: 'QueryProduct',
    data() {
        return {
            searchQuery: '',
            showResults: false,
            searchResults: [],
            searchHistory: [],
            recommenedProduct: [],
            allResults: [
                {
                    title: 'Vue.js 入门教程',
                    description: '学习Vue.js基础知识，包括指令、组件和响应式原理',
                    icon: 'fa-file-alt',
                    category: '教程'
                },
                {
                    title: 'Vue组件通信方式',
                    description: '详解Vue组件之间多种通信方法和使用场景',
                    icon: 'fa-puzzle-piece',
                    category: '教程'
                },
                {
                    title: 'Vuex状态管理指南',
                    description: '掌握Vuex的核心概念和使用方法，实现复杂状态管理',
                    icon: 'fa-database',
                    category: '教程'
                },
                {
                    title: 'Vue Router路由配置',
                    description: '学习Vue Router的安装、配置和动态路由使用',
                    icon: 'fa-route',
                    category: '教程'
                },
                {
                    title: 'Vue自定义指令',
                    description: '创建和使用自定义指令扩展Vue.js功能',
                    icon: 'fa-magic',
                    category: '进阶'
                },
                {
                    title: 'Vue混入(Mixins)使用',
                    description: '了解混入的概念和如何在不同组件间复用功能',
                    icon: 'fa-cubes',
                    category: '进阶'
                },
                {
                    title: 'Vue服务端渲染(SSR)',
                    description: '使用Nuxt.js实现Vue应用的服务端渲染',
                    icon: 'fa-server',
                    category: '进阶'
                },
                {
                    title: 'Vue性能优化技巧',
                    description: '提升Vue应用性能的实用技巧和最佳实践',
                    icon: 'fa-tachometer-alt',
                    category: '优化'
                }
            ]
        }
    },
    created() {
        this.getRecommenedProduct()
    },

    methods: {
        closeQuery() {
            console.log("closeQuery")
            this.$emit("QuerProducts", false)
        },
        jumpProductDetailPage(id) {
            this.$router.push({ path: "/products/productdetail", query: { id: id } })
        },
        async getRecommenedProduct() {
            this.recommenedProduct = []

            const { items } = await productApi.getProducts({ status: 1, isFeatured: true })
            this.recommenedProduct.push(...items)
        },
        handleSearch() {
            if (this.searchQuery.length > 0) {
                // 模拟搜索API调用
                this.searchResults = this.allResults.filter(item =>
                    item.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    item.description.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    item.category.toLowerCase().includes(this.searchQuery.toLowerCase())
                );
            } else {
                this.searchResults = [];
            }
        },

        async performSearch() {
            if (this.searchQuery.trim() === '') return;

            // 添加到搜索历史
            if (!this.searchHistory.includes(this.searchQuery)) {
                this.searchHistory.unshift(this.searchQuery);
                // 保持历史记录不超过10条
                if (this.searchHistory.length > 10) {
                    this.searchHistory.pop();
                }
            }

            this.showResults = false;
            // alert(`执行搜索: ${this.searchQuery}`);
            // 在实际应用中，这里会跳转到搜索结果页面或显示更多结果

            const { items } = await productApi.getProducts({ status: 1, keyword: this.searchQuery })
            this.searchResults = items
        },

        selectResult(result) {
            this.searchQuery = result.title;
            this.showResults = false;
            alert(`已选择: ${result.title}`);
            // 在实际应用中，这里会导航到对应的页面
        },

        applySuggestion(suggestion) {
            this.searchQuery = suggestion;
            this.handleSearch();
            this.showResults = true;
        },

        clearHistory() {
            this.searchHistory = [];
        }
    },
    mounted() {
        // 点击页面其他区域关闭搜索结果
        document.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.showResults = false;
            }
        });

        // 从本地存储加载搜索历史
        const savedHistory = localStorage.getItem('vueSearchHistory');
        if (savedHistory) {
            this.searchHistory = JSON.parse(savedHistory);
        }
    },
    watch: {
        searchHistory: {
            handler(newHistory) {
                // 保存搜索历史到本地存储
                localStorage.setItem('vueSearchHistory', JSON.stringify(newHistory));
            },
            deep: true
        }
    }
};
</script>

<style>
.item-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 30px;
}

.item-card {
    background: var(--white);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: var(--shadow);
    transition: var(--transition);
}

.item-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
}

.item-image {
    margin-top:20px;
    height: 200px;
    overflow: hidden;
}

.item-image img {
    width: 100%;
    height: 100%;
    display: block;
    margin: 0 auto;
    object-fit: contain;
    transition: var(--transition);
}

.item-card:hover .item-image img {
    transform: scale(1.05);
}

.search-header {
    text-align: center;
    margin: 50px 0;
    color: white;
}

.search-header h1 {
    font-size: 2.5rem;
    margin-bottom: 10px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.search-header p {
    font-size: 1.2rem;
    opacity: 0.9;
}

.search-container {
    width: 100%;
    position: relative;
    margin: 30px 0;
}

.search-box {
    display: flex;
    align-items: center;
    background: white;
    border-radius: 50px;
    padding: 10px 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
    border: 2px solid transparent;
}

.search-box:focus-within {
    border-color: #4dabf7;
    box-shadow: 0 10px 30px rgba(77, 171, 247, 0.4);
}

.search-icon {
    color: #6c757d;
    font-size: 1.2rem;
    margin-right: 15px;
}

.search-input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 1.1rem;
    padding: 12px 0;
    background: transparent;
}

.search-input::placeholder {
    color: #adb5bd;
}

.search-btn {
    background: #4dabf7;
    color: white;
    border: none;
    border-radius: 50px;
    padding: 12px 25px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.search-btn:hover {
    background: #339af0;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(51, 154, 240, 0.4);
}

.search-results {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border-radius: 15px;
    margin-top: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    z-index: 100;
    overflow: hidden;
    display: none;
}

.search-results.active {
    display: block;
}

.result-item {
    padding: 15px 20px;
    border-bottom: 1px solid #f1f3f5;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: background 0.2s ease;
}

.result-item:hover {
    background: #f8f9fa;
}

.result-icon {
    margin-right: 12px;
    color: #4dabf7;
}

.result-content h4 {
    margin-bottom: 5px;
    color: #343a40;
}

.result-content p {
    color: #6c757d;
    font-size: 0.9rem;
}

.search-suggestions {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
}

.suggestion-tag {
    background: rgba(255, 255, 255, 0.2);
    color: white;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid rgba(255, 255, 255, 0.3);
}

.suggestion-tag:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
}

.features {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
    width: 100%;
    margin-top: 50px;
}

.feature-card {
    background: white;
    border-radius: 15px;
    padding: 30px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
}

.feature-card:hover {
    transform: translateY(-5px);
}

.feature-icon {
    font-size: 2.5rem;
    color: #4dabf7;
    margin-bottom: 20px;
}

.feature-card h3 {
    margin-bottom: 15px;
    color: #343a40;
}

.feature-card p {
    color: #6c757d;
    line-height: 1.6;
}

.search-history {
    background: white;
    border-radius: 15px;
    padding: 25px;
    margin-top: 40px;
    width: 100%;
    max-width: 800px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.search-history h3 {
    margin-bottom: 20px;
    color: #343a40;
    display: flex;
    align-items: center;
    gap: 10px;
}

.history-items {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.history-item {
    background: #f8f9fa;
    padding: 8px 15px;
    border-radius: 20px;
    font-size: 0.9rem;
    color: #495057;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.history-item:hover {
    background: #e9ecef;
}

.clear-history {
    background: none;
    border: none;
    color: #6c757d;
    cursor: pointer;
    font-size: 0.9rem;
    margin-top: 15px;
    display: flex;
    align-items: center;
    gap: 5px;
}

.clear-history:hover {
    color: #495057;
}

@media (max-width: 768px) {

    .search-box {
        padding: 8px 15px;
    }

    .search-input {
        font-size: 1rem;
    }

    .search-btn {
        padding: 10px 20px;
    }

    .features {
        grid-template-columns: 1fr;
    }
}
</style>